import React, { useRef } from "react";
import { Checkbox } from "antd";
import { useDrag, useDrop } from "react-dnd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

const type = "COLUMN_ITEM";
const listColumnDisable = ["supplierCode", "supplierName"];
interface Props {
  id: string;
  index: number;
  label: string;
  checked: boolean;
  moveItem: (dragIndex: number, hoverIndex: number) => void;
  onToggle: () => void;
}

const DragItem: React.FC<Props> = ({ id, index, label, checked, moveItem, onToggle }) => {
  const ref = useRef<HTMLDivElement>(null);

  const [, drop] = useDrop({
    accept: type,
    hover(item: { index: number }) {
      if (item.index !== index) {
        moveItem(item.index, index);
        item.index = index;
      }
    },
  });

  const [, drag] = useDrag({
    type,
    item: { id, index },
  });

  drag(drop(ref));

  return (
    <div
      ref={ref}
      style={{
        border: "1px solid #d9d9d9",
        borderTopRightRadius: 8,
        borderBottomRightRadius: 8,
        marginBottom: 4,
        background: "#fff",
        cursor: "move",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#F7FAFF",
        }}
      >
        <FontAwesomeIcon icon={faBars} style={{ color: "#888", fontSize: 16 }} />
      </div>
      <div style={{ paddingLeft: 12,  }}>
        <Checkbox checked={checked} onChange={onToggle} disabled={listColumnDisable.includes(id)}>
          {label}
        </Checkbox>
      </div>
    </div>
  );
};

export default DragItem;
